

import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

// material-ui
// We no longer need makeStyles from the legacy styling engine.
// import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles'; // Import the modern useTheme hook
import { Card, CardContent, Divider, Grid, Typography } from '@mui/material';
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';

// project imports
import config from 'config';
import { gridSpacing } from 'utils/constant';

// assets
import AccountTreeTwoToneIcon from '@mui/icons-material/AccountTreeTwoTone';
import HomeIcon from '@mui/icons-material/Home';
import HomeTwoToneIcon from '@mui/icons-material/HomeTwoTone';

// The useStyles hook is no longer needed.

const Breadcrumbs = ({ card, divider, icon, icons, maxItems, navigation, rightAlign, separator, title, titleBottom, ...others }) => {
    // We no longer call useStyles().
    // const classes = useStyles();
    const theme = useTheme(); // Get the theme object correctly with the modern hook.

    const [main, setMain] = useState({});
    const [item, setItem] = useState({});

    // The styling logic from useStyles is now defined here as style objects for reusability.
    const linkStyle = {
        display: 'flex',
        color: theme.palette.grey[900],
        textDecoration: 'none',
        alignContent: 'center',
        alignItems: 'center'
    };

    const activeLinkStyle = {
        display: 'flex',
        textDecoration: 'none',
        alignContent: 'center',
        alignItems: 'center',
        color: theme.palette.grey[500]
    };

    const iconStyle = {
        marginRight: theme.spacing(0.75),
        marginTop: `-${theme.spacing(0.25)}`,
        width: '1rem',
        height: '1rem',
        color: theme.palette.primary.main
    };

    // The rest of your component's logic remains unchanged.
    const getCollapse = (item) => {
        if (item.children) {
            item.children.filter((collapse) => {
                if (collapse.type && collapse.type === 'collapse') {
                    getCollapse(collapse);
                } else if (collapse.type && collapse.type === 'item') {
                    if (document.location.pathname === config.basename + collapse.url) {
                        setMain(item);
                        setItem(collapse);
                    }
                }
                return false;
            });
        }
    };

    useEffect(() => {
        navigation.items.map((item) => {
            if (item.type && item.type === 'group') {
                getCollapse(item);
            }
            return false;
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navigation]);

    const SeparatorIcon = separator;
    const separatorIcon = separator ? <SeparatorIcon stroke={1.5} size="1rem" /> : '/';

    let mainContent;
    let itemContent;
    let breadcrumbContent = '';
    let itemTitle = '';
    let CollapseIcon;
    let ItemIcon;

    if (main && main.type === 'collapse') {
        CollapseIcon = main.icon ? main.icon : AccountTreeTwoToneIcon;
        mainContent = (
            <Typography component={Link} to="#" variant="subtitle1" sx={linkStyle}>
                {icons && <CollapseIcon style={iconStyle} />}
                {main.title}
            </Typography>
        );
    }

    if (item && item.type === 'item') {
        itemTitle = item.title;
        ItemIcon = item.icon ? item.icon : AccountTreeTwoToneIcon;
        itemContent = (
            <Typography variant="subtitle1" sx={activeLinkStyle}>
                {icons && <ItemIcon style={iconStyle} />}
                {itemTitle}
            </Typography>
        );

        if (item.breadcrumbs !== false) {
            breadcrumbContent = (
                <Card
                    sx={{
                        // Logic from the old `card` and `root` classes is now here
                        ...(card !== false && {
                            marginBottom: theme.spacing(gridSpacing),
                            border: '1px solid',
                            borderColor: theme.palette.primary[200] + '75'
                        }),
                        ...(card === false && {
                            background: 'transparent',
                            boxShadow: 'none',
                            border: 'none'
                        })
                    }}
                    {...others}
                >
                    <CardContent
                        sx={{
                            // Logic from the old `content` and `noPadding` classes is now here
                            ...(card !== false && { padding: '16px !important' }),
                            ...(card === false && { padding: '16px !important', paddingLeft: '0 !important' })
                        }}
                    >
                        <Grid
                            container
                            direction={rightAlign ? 'row' : 'column'}
                            justifyContent={rightAlign ? 'space-between' : 'flex-start'}
                            alignItems={rightAlign ? 'center' : 'flex-start'}
                            spacing={1}
                        >
                            {title && !titleBottom && (
                                <Grid item>
                                    <Typography variant="h3" sx={{ fontWeight: 500 }}>
                                        {item.title}
                                    </Typography>
                                </Grid>
                            )}
                            <Grid item>
                                <MuiBreadcrumbs aria-label="breadcrumb" maxItems={maxItems || 8} separator={separatorIcon}>
                                    <Typography component={Link} to="/" color="inherit" variant="subtitle1" sx={linkStyle}>
                                        {icons && <HomeTwoToneIcon style={iconStyle} />}
                                        {icon && <HomeIcon style={{ ...iconStyle, marginRight: 0 }} />}
                                        {!icon && 'Dashboard'}
                                    </Typography>
                                    {mainContent}
                                    {itemContent}
                                </MuiBreadcrumbs>
                            </Grid>
                            {title && titleBottom && (
                                <Grid item>
                                    <Typography variant="h3" sx={{ fontWeight: 500 }}>
                                        {item.title}
                                    </Typography>
                                </Grid>
                            )}
                        </Grid>
                    </CardContent>
                    {card === false && divider !== false && (
                        <Divider sx={{
                            borderColor: theme.palette.primary.main,
                            marginBottom: theme.spacing(gridSpacing)
                        }} />
                    )}
                </Card>
            );
        }
    }

    return breadcrumbContent;
};

Breadcrumbs.propTypes = {
    card: PropTypes.bool,
    divider: PropTypes.bool,
    icon: PropTypes.bool,
    icons: PropTypes.bool,
    maxItems: PropTypes.number,
    navigation: PropTypes.object,
    rightAlign: PropTypes.bool,
    separator: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    title: PropTypes.bool,
    titleBottom: PropTypes.bool
};

export default Breadcrumbs;
